<input readonly
  [disabled]="disabled"
  [minDate]="minDate"
  [maxDate]="maxDate"
  ngbDatepicker #dp="ngbDatepicker"
  [placement]="placement"
  [(ngModel)]="selectedDate"
  (dateSelect)="dateValueChange.emit($event)"
  [footerTemplate]="footerTemplate"
  (click)="!disabled ? dp.toggle() : null">
<label (click)="!disabled ? dp.toggle() : null">{{label}}</label>

<!-- firstDayOfWeek="7" -->
<ng-template #footerTemplate>
  <hr class="my-0">
  <div class="p-3 d-flex justify-content-between align-items-center">
    <button class="btn btn-primary btn-sm" type="button" [disabled]="disabled" (click)="setDate(today); dp.close()">{{ 'general.Today' | translate }}</button>
    <button class="btn btn-secondary btn-sm" type="button" [disabled]="disabled" (click)="setDate(); dp.close()">{{ 'general.Clear' | translate }}</button>
  </div>
</ng-template>
